module.exports = __webpack_public_path__ + "static/media/intro.c152fc4a.mp3";